import React from 'react';
import './ProcessNotice.css';
import Icon from '../home/Icon';

const TONE_ICON = { warning: 'warning', error: 'error', info: 'info', success: 'check_circle' };

/**
 * Inline notice of the process page (warnings, errors, hints) — same look as the former
 * .processMailWarning / .processInlineError boxes. `actions` renders buttons below the text.
 */
function ProcessNotice({ tone = 'warning', icon, title, children, actions, className = '' }) {
  return (
    <div className={`processNotice ${tone} ${className}`} role={tone === 'error' ? 'alert' : undefined}>
      <Icon icon={icon ?? TONE_ICON[tone] ?? 'info'} className={'processNoticeIcon'} />
      <div className={'processNoticeBody'}>
        {title && <strong className={'processNoticeTitle'}>{title}</strong>}
        {children && <div className={'processNoticeText'}>{children}</div>}
        {actions && <div className={'processNoticeActions'}>{actions}</div>}
      </div>
    </div>
  );
}

export default ProcessNotice;
